import { connect } from "react-redux";
import DealerView from "./DealerView";
import { bindActionCreators } from "redux";
import {ucdViewRequest} from "../../../../services/redux/CarLoan/action";

const mapStateToProps = (state) => ({
    ucdViewResponse : state.CarLoan.ucdViewResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        ucdViewRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DealerView);